import { useState, useEffect } from 'react'
import { WifiOff } from 'lucide-react'

/**
 * Banner that displays when the user is offline
 * Uses navigator.onLine and listens to online/offline events
 */
export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine)

  useEffect(() => {
    const handleOnline = () => setIsOffline(false)
    const handleOffline = () => setIsOffline(true)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  if (!isOffline) {
    return null
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-amber-500 text-white">
      <div className="max-w-2xl mx-auto px-4 py-2 flex items-center justify-center gap-2 text-sm font-medium">
        <WifiOff className="w-4 h-4" />
        <span>You're offline - showing cached data</span>
      </div>
    </div>
  )
}
